export default "__VITE_ASSET__D2I5mvXv__"